import React, { FC, memo, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { getSelectedUnitTypeFilter } from '../model/selectors/getSelectedFilter';
import { unitTypeFilterActions } from '../model/slice/unitTypeFilterSlice';
import { UnitType } from 'entities/Contract';
import { useUnitTypesFilters } from '../utils/hooks/useUnitTypesFilters';
import { FilterOption } from './FilterOption';

export const UnitTypeFilter: FC<Record<string, never>> = memo(() => {
  const dispatch = useAppDispatch();
  const { t } = useAppTranslation('booking');

  const selectedFilter = useAppSelector(getSelectedUnitTypeFilter);

  const unitTypeFilters = useUnitTypesFilters();

  const changeFilter = useCallback(
    (newFilter: UnitType): void => {
      dispatch(unitTypeFilterActions.changeFilter(newFilter));
    },
    [dispatch],
  );

  return (
    <div>
      <div className="mb-2">
        {Boolean(unitTypeFilters.length) && <div className="text-lg text-primaryLight">{t('Filter units by type:')}</div>}
      </div>
      <div className="flex space-x-2 overflow-x-auto pb-3">
        {unitTypeFilters.map(({ label, value }) => (
          <FilterOption key={value} label={label} value={value} isActive={selectedFilter === value} onChange={changeFilter} />
        ))}
      </div>
    </div>
  );
});
